import i18next from "i18next";
import * as yup from "yup";

export function validation(
  show,
  dod,
  theme,
  selectedDeathhDate,
  selectedBirthDate
) {
  const URL =
    /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;

  return yup.object().shape({
    firstName: yup
      .string()
      .required(i18next.t("validation.userAuth.firstName"))
      .min(2, "Minimum 2 Character required")
      .trim(i18next.t("validation.common.noSpace")),
    middleName: yup.string().min(2, "Minimum 2 Character required").trim(),
    lastName: yup
      .string()
      .required(i18next.t("validation.userAuth.lastName"))
      .min(3, "Minimum 3 Character required")
      .trim(i18next.t("validation.common.noSpace")),
    birthCity: yup
      .string()
      // .required("Birth city is required")
      .min(3, "Minimum 3 Character required")
      .trim(i18next.t("validation.common.noSpace")),
    birthStateId: yup
      // .required("Birth state is required")
      .string(),
    deathCity:
      dod === true
        ? yup
            .string()
            .min(3, "Minimum 3 Character required")
            .trim(i18next.t("validation.common.noSpace"))
        : // .required("Death city is required")
          null,
    deathStateId:
      dod === true
        ? yup.string()
        : // .required("Death state is required")
          null,
    birthDate: selectedBirthDate === null ? null : yup.string(),
    // .required("Birth date is required"),
    deathDate: selectedDeathhDate === null ? null : yup.string(),
    spouseName:
      show === true
        ? yup
            .string()
            .required(i18next.t("validation.createMemories.spouse"))
            .min(2, "Minimum 2 Character required")
            .trim(i18next.t("validation.common.noSpace"))
        : null,
    siblingName: yup.array(),
    childrenName: yup.array(),
    myBio: yup
      .string()
      .required(i18next.t("validation.createMemories.myBio"))
      .min(3, "Minimum 3 Character required")
      .trim(i18next.t("validation.common.noSpace")),
    ...((theme === "theme03" || theme === "theme04") && {
      bioLong: yup.string(),
      // .required(i18next.t("validation.createMemories.myBio")),
    }),
    instagram: yup
      .string()
      .matches(URL, i18next.t("validation.createMemories.validUrl")),
    facebook: yup
      .string()
      .matches(URL, i18next.t("validation.createMemories.validUrl")),
    twitter: yup
      .string()
      .matches(URL, i18next.t("validation.createMemories.validUrl")),
    maritalStatus: yup.string(),
    // .required("Marriage status is required"),
    dateOfMarriage:
      show === true
        ? yup
            .string()
            .nullable(false)
            .required(i18next.t("validation.createMemories.marriageDate"))
        : null,
    fatherName: yup
      .string()
      .min(2, "Minimum 2 Character required")
      .trim(i18next.t("validation.common.noSpace")),
    // .required(i18next.t("validation.createMemories.fatherName")),
    motherName: yup
      .string()
      .min(2, "Minimum 2 Character required")
      .trim(i18next.t("validation.common.noSpace")),
    // .required(i18next.t("validation.createMemories.motherName")),
    ...(theme === "theme01" && {
      profileImage: yup.string().required("Profile Image is required"),
    }),
    coverImage: yup.string().required("Cover Image is required"),
    birthCountryId: yup.string(),
    // .required("Birth country is required"),
    deathCountryId:
      dod === true
        ? yup.string()
        : // .required("Death country is required")
          null,
    location: yup.string(),
    // .required(i18next.t("validation.createMemories.location")),
  });
}
